export { getMockedCertmetricsCertificatesEdges } from './getMockedCertmetricsCertificatesEdges';
